import { apiHelpers } from '../api';
import type { User } from '@/types/auth';

export interface UpdateProfileRequest {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string | undefined;
  dateOfBirth?: string | undefined;
  nationality?: string | undefined;
  address?: string | undefined;
  postalCode?: string | undefined;
  city?: string | undefined;
  country?: string | undefined;
}

export interface UpdateProfileResponse {
  success: boolean;
  data: {
    user: User;
  };
  message: string;
}

export const userApi = {
  /**
   * Update user profile
   */
  updateProfile: async (profileData: UpdateProfileRequest): Promise<UpdateProfileResponse> => {
    const response = await apiHelpers.put<UpdateProfileResponse>('/users/profile', profileData);
    return response.data;
  },

  /**
   * Get current user profile
   */
  getProfile: async (): Promise<{ success: boolean; data: { user: User } }> => {
    const response = await apiHelpers.get<{ success: boolean; data: { user: User } }>('/users/profile');
    return response.data;
  }
};